import { render } from "./FacturatieView.vue?vue&type=template&id=569adcac"
import script from "./FacturatieView.vue?vue&type=script&lang=js"
export * from "./FacturatieView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__